module.exports = __webpack_public_path__ + "static/media/off.700f9d5f.svg";